import { ChevronLeft, Crown, Check } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { BottomNav } from "@/components/BottomNav";

const Subscription = () => {
  const navigate = useNavigate();

  const plans = [
    {
      name: "Free",
      price: "$0",
      period: "/month",
      features: [
        "1 Brain Colony",
        "Basic chat mode",
        "Limited messages",
        "Community support"
      ],
      current: true
    },
    {
      name: "Pro",
      price: "$9.99",
      period: "/month",
      features: [
        "5 Brain Colonies",
        "All modes (Chat, Debate, Autonomous)",
        "Unlimited messages",
        "Priority support",
        "Custom brain personalities",
        "Advanced analytics"
      ],
      current: false,
      popular: true
    },
    {
      name: "Teams",
      price: "$19.99",
      period: "/month",
      features: [
        "Unlimited Brain Colonies",
        "Team collaboration",
        "Shared knowledge base",
        "Admin controls",
        "API access",
        "24/7 support"
      ],
      current: false
    }
  ];

  return (
    <div className="min-h-screen bg-background safe-area-top safe-area-bottom">
      {/* Header */}
      <div className="flex items-center justify-between px-4 py-3 border-b border-ios-separator bg-ios-surface">
        <Button 
          variant="ghost" 
          size="icon"
          onClick={() => navigate("/settings")}
          className="text-foreground hover:bg-ios-surface-secondary w-11 h-11 rounded-full"
        >
          <ChevronLeft size={22} />
        </Button>
        <h1 className="ios-title text-foreground">Subscription</h1>
        <div className="w-11" />
      </div>

      {/* Subscription Content */}
      <div className="flex-1 p-4 space-y-4">
        {plans.map((plan, index) => (
          <div
            key={index}
            className={`relative bg-ios-surface border rounded-2xl p-6 ${
              plan.popular 
                ? 'border-ios-blue ring-2 ring-ios-blue/20' 
                : 'border-ios-separator'
            }`}
          >
            {plan.popular && (
              <div className="absolute -top-3 left-1/2 transform -translate-x-1/2">
                <div className="bg-ios-blue text-white px-3 py-1 rounded-full text-xs font-medium flex items-center">
                  <Crown size={12} className="mr-1" />
                  Most Popular
                </div>
              </div>
            )}
            
            <div className="text-center mb-4">
              <h3 className="text-xl font-bold text-foreground">{plan.name}</h3>
              <div className="mt-2">
                <span className="text-3xl font-bold text-foreground">{plan.price}</span>
                <span className="text-muted-foreground">{plan.period}</span>
              </div>
            </div>

            <div className="space-y-3 mb-6">
              {plan.features.map((feature, featureIndex) => (
                <div key={featureIndex} className="flex items-center">
                  <Check size={16} className="text-ios-green mr-3 flex-shrink-0" />
                  <span className="text-sm text-foreground">{feature}</span>
                </div>
              ))}
            </div>

            <Button
              className={`w-full h-12 font-medium rounded-xl ${
                plan.current
                  ? 'bg-ios-surface-secondary text-muted-foreground cursor-not-allowed'
                  : plan.popular
                  ? 'bg-ios-blue text-white hover:bg-ios-blue/90'
                  : 'bg-ios-surface-secondary text-foreground hover:bg-ios-surface-tertiary border border-ios-separator'
              }`}
              disabled={plan.current}
            >
              {plan.current ? 'Current Plan' : `Upgrade to ${plan.name}`}
            </Button>
          </div>
        ))}
      </div>

      <BottomNav currentPage="settings" />
    </div>
  );
};

export default Subscription;